export const EMPTY_NARRATIVES = [];
export const NARRATIVE_CREATED_LABEL_FADE_DURATION_MS = 350;
export const NARRATIVE_CREATED_LABEL = 'Created a new Narrative…';
export const NARRATIVE_CREATING_LABEL = 'Creating a new Narrative…';
